module.exports = __webpack_public_path__ + "media/images/home_white-2418e7086184714eb297911fd4519c90.png";